module.exports = __webpack_public_path__ + "img/works_feilang_go_2.59d3b39e.png";